import { selectors as streamSelectors } from '../../Stream';
import {
  watchedGroupsStreamId,
  recommendedGroupsStreamId,
  reduxKey,
} from './constants';
import { NetworkBarStoreSlice, NetworkBarStreamTypes } from './types';
import { getIsLoggedIn } from '../../publicSession/selectors';
import { PapiUser } from '@wix/da-papi-types';
import { getDataEntitiesByIds } from '../../redux/entities/selectors';
import { userSchema } from '../../redux/normalizr/schemas/user';

function getNetworkBarState(state: any): NetworkBarStoreSlice {
  return (
    state[reduxKey] ?? {
      isInitialized: false,
      mainNavItems: [],
    }
  );
}

export function getIsNetworkBarInitialized(state: any) {
  return getNetworkBarState(state).isInitialized;
}

export function isNetworkBarLoading(state: any) {
  return (
    !streamSelectors.isInitialized(state, watchedGroupsStreamId) ||
    !streamSelectors.isInitialized(state, recommendedGroupsStreamId) ||
    streamSelectors.isFetching(state, watchedGroupsStreamId) ||
    streamSelectors.isFetching(state, recommendedGroupsStreamId)
  );
}

export function getCanUserHaveWatchedGroups(state: any) {
  return (
    getIsLoggedIn(state) &&
    (streamSelectors.getItems(state, watchedGroupsStreamId).length > 0 ||
      streamSelectors.isFetching(state, watchedGroupsStreamId) ||
      streamSelectors.hasMore(state, watchedGroupsStreamId))
  );
}

export function getCanUserHaveRecommendedGroups(state: any) {
  return (
    getIsLoggedIn(state) &&
    (streamSelectors.getItems(state, recommendedGroupsStreamId).length > 0 ||
      streamSelectors.isFetching(state, recommendedGroupsStreamId) ||
      streamSelectors.hasMore(state, recommendedGroupsStreamId))
  );
}

export function getMainNavItems(state: any) {
  return getNetworkBarState(state).mainNavigation;
}

export function getIsSectionFolded(state: any, section: NetworkBarStreamTypes) {
  return getNetworkBarState(state).sections[section].isFolded;
}

export function getHasUnreadContent(state: any) {
  // TODO: in theory backend will return us a convenient flag soon
  if (getMainNavItems(state).some(item => item.hasNewContent)) {
    return true;
  }

  const watchedGroupIds = streamSelectors.getItems<number>(
    state,
    watchedGroupsStreamId
  );

  if (!watchedGroupIds?.length) {
    return false;
  }

  const watchedGroups = getDataEntitiesByIds<PapiUser>(
    state,
    userSchema,
    watchedGroupIds
  );
  return watchedGroups.some(group => group.networkbar?.hasNewContent);
}
